import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Star, Quote } from 'lucide-react';
import DisplayCards from '@/components/ui/display-cards';

const Reviews = () => {
  const reviewsData = [
    {
      reviewBody: "I Could Never Turn My Phone Off. I Can Finally Switch Off",
      author: "Cara-June",
      authorJobTitle: "Managing Director",
      ratingValue: 5,
      datePublished: "2024-09-16"
    },
    {
      reviewBody: "We Saved Countless Hours Per Week. Game-Changing Automation",
      author: "Peter McCann",
      authorJobTitle: "Managing Director", 
      ratingValue: 5,
      datePublished: "2025-03-23"
    },
    {
      reviewBody: "We Cut Down Our Team By 40%. It's Frighteningly Efficient",
      author: "Chris Reid",
      authorJobTitle: "Managing Director",
      ratingValue: 5,
      datePublished: "2025-07-09"
    }
  ];

  const aggregateRating = {
    "@context": "https://schema.org",
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "3",
    "bestRating": "5",
    "worstRating": "5"
  };

  const reviewsSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Njord AI Automation Agency",
    "aggregateRating": aggregateRating,
    "review": reviewsData.map(review => ({
      "@type": "Review",
      "reviewBody": review.reviewBody,
      "author": {
        "@type": "Person",
        "name": review.author,
        "jobTitle": review.authorJobTitle
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": review.ratingValue,
        "bestRating": "5",
        "worstRating": "1"
      },
      "datePublished": review.datePublished,
      "itemReviewed": {
        "@type": "Service",
        "name": "AI Automation Services",
        "description": "Custom AI automation solutions for business growth"
      }
    }))
  };

  const reviews = [
    {
      icon: <Quote className="size-4 text-primary-300" />,
      title: "I Can Finally Switch Off",
      description: "I Could Never Turn My Phone Off",
      date: "Cara-June, Managing Director",
      iconClassName: "text-primary-300",
      titleClassName: "text-primary-300",
      className: "[grid-area:stack] hover:-translate-y-10 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-background/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration:700 hover:grayscale-0 before:left-0 before:top-0",
    },
    {
      icon: <Quote className="size-4 text-primary-300" />,
      title: "Game-Changing Automation",
      description: "We Saved Countless Hours Per Week",
      date: "Peter McCann, Managing Director",
      iconClassName: "text-primary-300",
      titleClassName: "text-primary-300",
      className: "[grid-area:stack] translate-x-24 translate-y-16 hover:-translate-y-1 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-background/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration:700 hover:grayscale-0 before:left-0 before:top-0",
    },
    {
      icon: <Quote className="size-4 text-primary-300" />,
      title: "It's Frighteningly Efficient",
      description: "We Cut Down Our Team By 40%",
      date: "Chris Reid, Managing Director",
      iconClassName: "text-primary-300",
      titleClassName: "text-primary-300",
      className: "[grid-area:stack] translate-x-48 translate-y-32 hover:translate-y-16",
    },
  ];

  return (
    <>
      <Helmet>
        {/* Review Schema */}
        <script type="application/ld+json">
          {JSON.stringify(reviewsSchema)}
        </script>
      </Helmet>
      
      <section id="reviews" className="hidden md:block section bg-black py-16">
        <div className="container">
          <div className="text-center mb-6">
            <div className="flex justify-center mb-4">
              <div className="flex space-x-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-6 w-6 text-primary-300 fill-primary-300" />
                ))}
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              What Our Clients Say
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Real feedback from businesses that have transformed their operations with our AI automation solutions.
            </p>
          </div>

          <div className="h-[450px] flex items-center justify-center">
            <DisplayCards cards={reviews} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;